/**
 * The environment this build talks to, and its management API host. Kept free of imports so
 * `appInsights.ts` can read the host: `appServices.ts` pulls in `restClient` → `logger` →
 * `appInsights`, which would make that a cycle.
 */
export enum AppEnv {
  Production = "prod",
  Test = "test",
  Development = "dev",
  Local = "local",
}

export const APP_ENV: AppEnv =
  import.meta.env.VITE_APP_ENV || AppEnv.Production;

const management_api_hosts: Record<AppEnv, string> = {
  [AppEnv.Production]: "api.lara.law",
  [AppEnv.Test]: "test.api.lara.law",
  [AppEnv.Development]: "dev.api.lara.law",
  [AppEnv.Local]: "localhost:5297",
};

export const MANAGEMENT_API_HOST =
  management_api_hosts[APP_ENV] ?? management_api_hosts[AppEnv.Production];
